<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-12 sp-0">
        <ng-container *ngIf="tabletSize.matches">
            <tt-page-heading
                *ngIf="p2DataTaskKeyno === '0'"
                ttModel="h_stored_procedure_new"
                ttTranslate>
            </tt-page-heading>
            <tt-page-heading
                *ngIf="p2DataTaskKeyno !== '0'"
                ttModel="h_stored_procedure"
                ttTranslate>
            </tt-page-heading>
            <div class="k-hr col-xs-12 sp-0"></div>
        </ng-container>

        <tt-input ttLabel="p2_datatask_keyno" [ttModel]="page.p2_datatask_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="proc_name" [(ttModel)]="page.proc_name"></tt-input>
        <tt-checkbox ttLabel="manual_parm" [(ttModel)]="page.manual_parm"></tt-checkbox>
        <tt-checkbox ttLabel="is_report" [(ttModel)]="page.is_report"></tt-checkbox>
        <tt-checkbox ttLabel="set_parms" [(ttModel)]="page.set_parms"></tt-checkbox>
        <tt-checkbox ttLabel="encoded_parms" [(ttModel)]="page.encoded_parms"></tt-checkbox>
        <tt-checkbox ttLabel="encoded_data" [(ttModel)]="page.encoded_data"></tt-checkbox>
        <tt-datetime ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttMinutePrecision="1" ttReadonly></tt-datetime>
        <tt-datetime ttLabel="mod_datetime" [ttModel]="page.mod_datetime" ttMinutePrecision="1" ttReadonly></tt-datetime>
        <tt-button-save [ttLocked]="lockedSave" (ttClick)="saveChanges()"></tt-button-save>
    </tt-card>
</tt-page>
